import { CONFIG } from "~/config";
import { timePassed } from "~/util/format";

export interface INewsResponse {
	documents: Array<{
		attributes: {
			lastChangeDate: number;
			publicationDate: number;
		}
		snippet: {
			description: string;
			title: string;
			url: string;
			urlHighlighted: string;
			domain: string;
		}
		favicons: Array<{
			size: number;
			url: string;
		}>
		thumbnails: Array<{
			type: "mainImage"|"default";
			url: string;
		}>
	}>;
	urlMore: string;
}

export interface INewsItem {
	url: string;
	title: string;
	cover: string;
	date: string;
	source: string;
}

export async function getNews(query: string): Promise<Array<INewsItem>> {
	try {
		const response = await fetch(`${CONFIG.requestUrl}/poiagghttp/poi_news/${query}/`);
		const json = await response.json() as INewsResponse;

		if (response.status >= 200 && response.status < 300) {
			return json.documents.map(docItem => ({
				url: docItem.snippet.url,
				title: docItem.snippet.title,
				cover: docItem.thumbnails?.filter(item => item.type === "mainImage")[0]?.url || "",
				/* eslint-disable-next-line */
				date: docItem.attributes?.publicationDate ? timePassed(new Date(docItem.attributes.publicationDate * 1000)) : "",
				source: docItem.snippet.domain,
			}));
		}

		return [];
	} catch (exc) {
		return [];
	}
}

interface IGetViewportNews {
	xmin: number;
	ymin: number;
	xmax: number;
	ymax: number;
	limit: number;
}

//https://pro.mapy.dev.dszn.cz/poiagghttp/viewport_news/?xmin=14.4009907&ymin=50.0164239&xmax=14.5355732&ymax=50.0894999&limit=2
export async function getViewportNews(params: IGetViewportNews): Promise<Array<INewsItem>> {
	try {
		const usp = new URLSearchParams();

		Object.keys(params).forEach(name => {
			usp.append(name, params[name]);
		});

		const response = await fetch(`${CONFIG.requestUrl}/poiagghttp/viewport_news/?${usp.toString()}`);
		const json = await response.json() as INewsResponse;

		if (response.status >= 200 && response.status < 300) {
			return json.documents.map(docItem => ({
				url: docItem.snippet.url,
				title: docItem.snippet.title,
				cover: docItem.thumbnails?.filter(item => item.type === "mainImage")[0]?.url || "",
				/* eslint-disable-next-line */
				date: docItem.attributes?.publicationDate ? timePassed(new Date(docItem.attributes.publicationDate * 1000)) : "",
				source: docItem.snippet.domain,
			}));
		}

		return [];
	} catch (exc) {
		return [];
	}
}
